import { object } from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Table, CardTitle } from "reactstrap"


export const expandRow = {
  
  renderer: row => (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-3">Customer Summary</CardTitle>

          <div className="table-responsive">
            <Table className="table mb-0">
              <tbody>
                <tr>
                  <th>Cell</th>
                  <td>
                    {row.cell}
                  </td>
                </tr>
                <tr>
                  <th>Fax </th>
                  <td>{row.price}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{row.email}</td>
                </tr>
                <tr>
                  <th>Invoice Email</th>
                  <td>{row.invoiceEmail}</td>
                </tr>
                <tr>
                  <th>Optional Email</th>
                  <td>{row.optionalEmail}</td>
                </tr>
                <tr>
                  <th>Registerd Date</th>
                  <td>{row.registerdDate}</td>
                </tr>
                <tr>
                  <th>User Name</th>
                  <td>{row.userName}</td>
                </tr>
                <tr>
                  <th>Password</th>
                  <td>{row.password}</td>
                </tr>
                <tr>
                  <th>Country</th>
                  <td>{row.country}</td>
                </tr>
                <tr>
                  <th>Customer Id</th>
                  <td>{row.id}</td>
                </tr>
                <tr>
                  <th>Ip Details</th>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <th>Ip : </th>
                          <td>
                            {JSON.parse(row.ipInfo).ip}
                          </td>
                          <th> | Country : </th>
                          <td>
                            {JSON.parse(row.ipInfo).country_name}
                          </td>
                          <th> | City : </th>
                          <td>
                            {JSON.parse(row.ipInfo).city}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  ),
  showExpandColumn: true,       // ✅ show the expand (+) column
  expandByColumnOnly: true,     // ✅ expand ONLY when clicking the +/–
  expandHeaderColumnRenderer: ({ isAnyExpands }) => {
    return isAnyExpands ? '👇' : '👉'; // optional custom header icon
  },
  expandColumnRenderer: ({ expanded }) => {
    return expanded ? (<span style={{ cursor: "pointer" }}>➖</span>) : (<span style={{ cursor: "pointer" }}>➕</span>); // ✅ icons for expand/collapse
  }

  // showExpandColumn: false,
}
